export const environment = {
  production: false,
  apiUrl: 'https://dev-api.clubs.tatamiq.org/api',
};
